import { render, staticRenderFns } from "./CardProperty.vue?vue&type=template&id=229c5b9a"
import script from "./CardProperty.vue?vue&type=script&lang=js"
export * from "./CardProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports